module.exports = __webpack_public_path__ + "static/media/bank.e24cde42.jpg";